<template>
  <el-form :model="form" :rules="rules" ref="form" class="data-card">
    <div class="data-card__header">
      <div class="d-flex align-items-baseline flex-wrap">
        <h3 class="my-0 mr-3">Рекламация</h3>
        <span>от {{dateFormatToMoscowTime(claimData.createdAt)}}(МСК)</span>
      </div>
      <div class="d-flex">
        <el-form-item prop="isProcessed">
          <el-select v-model="form.isProcessed" placeholder="Статус рекламации" size="medium"
                     :disabled="!isEdited || !$isAccess($userRoles.Admin, $userRoles.Specialist)">
            <el-option v-for="option in claimStatuses" :key="option.id" :label="option.label" :value="option.value" />
          </el-select>
        </el-form-item>
        <div v-if="$isAccess($userRoles.Admin, $userRoles.Specialist, $userRoles.Dispatcher) && $user.workWithOrdersAccess" class="ml-3">
          <el-button v-if="isEdited" type="primary" size="medium" :loading="updateProgress || uploadFileCount>0" @click="onSave">
            Сохранить
          </el-button>
          <el-button v-else size="medium" @click="isEdited=true" :loading="updateProgress">
            Изменить
          </el-button>
        </div>
      </div>
    </div>

    <div class="mt-3">
      <el-form-item prop="reasonId">
        <el-select v-model="form.reasonId" filterable class="w-100" size="medium"
                   :disabled="!isEdited || !$isAccess($userRoles.Admin, $userRoles.Dispatcher)"
                   :loading="fetchClaimsProgress" placeholder="" ref="reasonIdRef">
          <el-option v-for="option in claimsFiltered" :key="option.id" :label="option.displayName" :value="option.id" />
        </el-select>
        <span class="floating-span"
              :class="{'floating-span_active': $notEmpty(form.reasonId) || $notEmpty($refs.reasonIdRef && $refs.reasonIdRef.query)}">
          Выберите причину
        </span>
      </el-form-item>

      <el-form-item prop="comment" class="mt-3">
        <el-input type="textarea"
                  :rows="4"
                  maxlength="200"
                  show-word-limit
                  v-model="form.comment"
                  :disabled="!isEdited"
                  resize="none"/>
        <span class="floating-span" :class="{ 'floating-span_active': $notEmpty(form.comment) }">Комментарий</span>
      </el-form-item>
    </div>

    <FilesBlock :files="form.files" :isEdited="isEdited && $isAccess($userRoles.Admin, $userRoles.Dispatcher)" @onRemove="onRemoveFile" />

    <div class="d-flex flex-wrap flex-gap-10 mt-3">
      <el-form-item v-if="isEdited && $isAccess($userRoles.Admin, $userRoles.Dispatcher)" prop="files">
        <el-upload ref="upload" action="/" multiple
                   :show-file-list="false" :auto-upload="false"
                   :on-change="onChangeFiles">
          <el-button slot="trigger" icon="el-icon-plus" size="medium">
            Прикрепить файл
          </el-button>
        </el-upload>
      </el-form-item>

      <div v-if="showSaveAllFiles">
        <el-button size="medium" @click="onSaveAllFiles">Скачать все файлы</el-button>
      </div>
    </div>

  </el-form>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import claimStatuses from '@/commons/constants/claimStatuses';
import { MESSAGES } from '@/commons/constants/errorMessages';
import FilesBlock from '@/components/ui/FilesBlock';
import apiClient from '@/services/api/apiClient';
import { dateFormatToMoscowTime } from '@/commons/helpers';

export default {
  components: {
    FilesBlock,
  },
  data: () => ({
    isEdited: false,
    uploadFileCount: 0,
    claimStatuses,
    form: {
      isProcessed: false,
      reasonId: null,
      comment: '',
      files: [],
    },
    rules: {
      isProcessed: [
        { required: true, message: MESSAGES.REQUIRED, trigger: 'change' },
      ],
      reasonId: [
        { required: true, message: MESSAGES.REQUIRED, trigger: 'change' },
      ],
    },
  }),
  computed: {
    ...mapGetters({
      item: 'orders/item',
      updateProgress: 'orders/updateProgress',
      claims: 'claimReasonsDrop/items',
      fetchClaimsProgress: 'claimReasonsDrop/fetchProgress',
    }),
    claimData() {
      return this.item.claimData;
    },
    claimsFiltered() {
      return this.claims.filter((x) => !x.isArchived || this.claimData?.reasonId === x.id);
    },
    showSaveAllFiles() {
      return this.claimData.files.length;
    },
  },
  methods: {
    ...mapActions({
      fetchClaims: 'claimReasonsDrop/fetchItems',
      updateClaim: 'orders/updateClaim',
      uploadFileGetUrl: 'files/uploadFileGetUrl',
      getZipKey: 'files/getZipKey',
    }),
    dateFormatToMoscowTime,
    fillForm() {
      if (this.claimData) {
        this.form.isProcessed = this.claimData.isProcessed;
        this.form.reasonId = this.claimData.reasonId;
        this.form.comment = this.claimData.comment;
        this.form.files = [...this.claimData.files];
      } else {
        this.form.isProcessed = false;
        this.form.reasonId = null;
        this.form.comment = '';
        this.form.files = [];
      }
    },
    onChangeFiles(evt) {
      this.uploadFileCount += 1;
      this.uploadFileGetUrl({ file: evt.raw })
        .then((file) => {
          this.form.files.push(file);
        })
        .finally(() => {
          this.uploadFileCount -= 1;
        });
    },
    onRemoveFile(file) {
      const fileIndex = this.form.files.findIndex((f) => f.id === file.id);
      if (fileIndex > -1) {
        this.form.files.splice(fileIndex, 1);
      }
    },
    onSaveAllFiles() {
      const { files } = this.claimData;
      this.getZipKey({ files })
        .then((data) => {
          const link = document.createElement('a');
          link.href = `${apiClient.defaults.baseURL}/files/zip/${data.downloadKey}`;
          link.click();
        });
    },
    onSave() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const { id } = this.item;
          const data = {
            ...this.form,
          };
          this.updateClaim({ id, data })
            .then(() => {
              this.isEdited = false;
            });
        }
      });
    },
  },
  created() {
    this.fetchClaims();
    this.fillForm();
  },
  watch: {
    item() {
      this.isEdited = false;
      this.fillForm();
    },
  },
};
</script>
